import { EXTERNAL_ROUTES } from '../constants/routerpath'
import { setSessionStorageValue } from '../utils/sessionUtils'

export const routeController = (sharedData) => {
  const {
    currentPath,
    AppFlow,
    AppError,
    params,
    successMsg = null,
    payeeId = null,
    navTo = null,
    link = null,
    linkurl = null,
    fromPayee = '',
    siderrailLoad,
    type
  } = sharedData

  delete sessionStorage.billpayDeepLinkNew

  const getNextIndex = () => {
    let tempNextPageURL = ''
    const tempPrevPageURL = currentPath

    const billpayDeepLink = {
      message: '',
      accountId: payeeId,
      navTo,
      successMsg,
      isPmMsg: true,
      link,
      linkurl,
      fromPayee,
      siderrailLoad,
      type
    }

    switch (AppFlow) {
      case 'OPENBILLPAY':
        setSessionStorageValue(
          'billpayDeepLink',
          JSON.stringify(billpayDeepLink)
        )
        window.location.href = EXTERNAL_ROUTES.openbillpay
        break
      case 'PAYEE_MANAGEMENT':
        setSessionStorageValue(
          'billpayDeepLink',
          JSON.stringify(billpayDeepLink)
        )
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(billpayDeepLink))
        window.location.href = EXTERNAL_ROUTES.payeemanagement
        break
      default:
    }

    tempNextPageURL = params ? tempNextPageURL + params : tempNextPageURL

    return { nextPageURL: tempNextPageURL, prevPageURL: tempPrevPageURL }
  }
  const { nextPageURL, prevPageURL } = getNextIndex()

  return {
    nextPage: !AppError ? nextPageURL : '',
    previousPage: !AppError ? prevPageURL : ''
  }
}

export default routeController
